"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _SVBButton = require("../../SVBButton");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Global components
 * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
 * Summary
 * This component renders SVB Explore API Example
 */

const ApiExploreCard = props => {
  var _props$title, _props$description, _props$buttonText;
  const title = (_props$title = props === null || props === void 0 ? void 0 : props.title) !== null && _props$title !== void 0 ? _props$title : "";
  const description = (_props$description = props === null || props === void 0 ? void 0 : props.description) !== null && _props$description !== void 0 ? _props$description : "";
  const buttonText = (_props$buttonText = props === null || props === void 0 ? void 0 : props.buttonText) !== null && _props$buttonText !== void 0 ? _props$buttonText : "View Apis";
  const handleButtonClick = props === null || props === void 0 ? void 0 : props.handleButtonClick;
  const indexValue = props === null || props === void 0 ? void 0 : props.indexValue;
  const icon = props === null || props === void 0 ? void 0 : props.icon;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col exploreApi-card-container p-4 s".concat(indexValue)
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: icon
  }), /*#__PURE__*/_react.default.createElement("h2", {
    className: "heading-medium pt-3 font-family-roboto",
    style: {
      color: "#3A3A3A"
    }
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "paragraph font-family-roboto"
  }, description), /*#__PURE__*/_react.default.createElement(_SVBButton.SVBButton, {
    rightIconExtraClasses: "exploreApi-button-icon",
    extraClasses: "border-0 exploreApi-card-button sub-heading font-family-roboto exploreApi-font-white",
    text: buttonText,
    size: "large",
    style: "primary",
    state: "default",
    type: "text",
    icon: "down",
    iconSide: "right",
    onClick: handleButtonClick
  }));
};
var _default = ApiExploreCard;
exports.default = _default;